export type ThemeVariant = "bold" | "medium" | "soft";

export interface Theme {
  id: string;
  industry: string;
  subType: string;
  variant: ThemeVariant;
  imageUrl: string;
  label: string;
}

export const themes: Theme[] = [
  {
    "id": "healthcare-general-doctor-bold",
    "industry": "Healthcare & Wellness",
    "subType": "General Doctor / Clinic",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600&h=900&fit=crop",
    "label": "General Doctor / Clinic – Bold"
  },
  {
    "id": "healthcare-general-doctor-medium",
    "industry": "Healthcare & Wellness",
    "subType": "General Doctor / Clinic",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1504813184591-01572f98c85f?w=600&h=900&fit=crop",
    "label": "General Doctor / Clinic – Medium"
  },
  {
    "id": "healthcare-general-doctor-soft",
    "industry": "Healthcare & Wellness",
    "subType": "General Doctor / Clinic",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600&h=900&fit=crop",
    "label": "General Doctor / Clinic – Soft"
  },
  {
    "id": "healthcare-dentist-bold",
    "industry": "Healthcare & Wellness",
    "subType": "Dentist",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=600&h=900&fit=crop",
    "label": "Dentist – Bold"
  },
  {
    "id": "healthcare-dentist-medium",
    "industry": "Healthcare & Wellness",
    "subType": "Dentist",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=600&h=900&fit=crop",
    "label": "Dentist – Medium"
  },
  {
    "id": "healthcare-dentist-soft",
    "industry": "Healthcare & Wellness",
    "subType": "Dentist",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&h=900&fit=crop",
    "label": "Dentist – Soft"
  },
  {
    "id": "healthcare-ayurveda-traditional-medicine-bold",
    "industry": "Healthcare & Wellness",
    "subType": "Ayurveda / Traditional Medicine",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=600&h=900&fit=crop",
    "label": "Ayurveda / Traditional Medicine – Bold"
  },
  {
    "id": "healthcare-ayurveda-traditional-medicine-medium",
    "industry": "Healthcare & Wellness",
    "subType": "Ayurveda / Traditional Medicine",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1596178065887-1198b6148b2b?w=600&h=900&fit=crop",
    "label": "Ayurveda / Traditional Medicine – Medium"
  },
  {
    "id": "healthcare-ayurveda-traditional-medicine-soft",
    "industry": "Healthcare & Wellness",
    "subType": "Ayurveda / Traditional Medicine",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&h=900&fit=crop",
    "label": "Ayurveda / Traditional Medicine – Soft"
  },
  {
    "id": "healthcare-physiotherapy-rehab-bold",
    "industry": "Healthcare & Wellness",
    "subType": "Physiotherapy / Rehab",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=900&fit=crop",
    "label": "Physiotherapy / Rehab – Bold"
  },
  {
    "id": "healthcare-physiotherapy-rehab-medium",
    "industry": "Healthcare & Wellness",
    "subType": "Physiotherapy / Rehab",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&h=900&fit=crop",
    "label": "Physiotherapy / Rehab – Medium"
  },
  {
    "id": "healthcare-physiotherapy-rehab-soft",
    "industry": "Healthcare & Wellness",
    "subType": "Physiotherapy / Rehab",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1643386877851-5b4202ece1ee?w=600&h=900&fit=crop",
    "label": "Physiotherapy / Rehab – Soft"
  },
  {
    "id": "healthcare-mental-health-counselling-bold",
    "industry": "Healthcare & Wellness",
    "subType": "Mental Health / Counselling",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1516302752625-fcc3c50ae61f?w=600&h=900&fit=crop",
    "label": "Mental Health / Counselling – Bold"
  },
  {
    "id": "healthcare-mental-health-counselling-medium",
    "industry": "Healthcare & Wellness",
    "subType": "Mental Health / Counselling",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1527137342181-19aab11a8ee8?w=600&h=900&fit=crop",
    "label": "Mental Health / Counselling – Medium"
  },
  {
    "id": "healthcare-mental-health-counselling-soft",
    "industry": "Healthcare & Wellness",
    "subType": "Mental Health / Counselling",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=900&fit=crop",
    "label": "Mental Health / Counselling – Soft"
  },
  {
    "id": "healthcare-beauty-skincare-clinic-bold",
    "industry": "Healthcare & Wellness",
    "subType": "Beauty & Skincare Clinic",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600&h=900&fit=crop",
    "label": "Beauty & Skincare Clinic – Bold"
  },
  {
    "id": "healthcare-beauty-skincare-clinic-medium",
    "industry": "Healthcare & Wellness",
    "subType": "Beauty & Skincare Clinic",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=600&h=900&fit=crop",
    "label": "Beauty & Skincare Clinic – Medium"
  },
  {
    "id": "healthcare-beauty-skincare-clinic-soft",
    "industry": "Healthcare & Wellness",
    "subType": "Beauty & Skincare Clinic",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1519415510236-718bdfcd89c8?w=600&h=900&fit=crop",
    "label": "Beauty & Skincare Clinic – Soft"
  },
  {
    "id": "healthcare-pharmacy-bold",
    "industry": "Healthcare & Wellness",
    "subType": "Pharmacy",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&h=900&fit=crop",
    "label": "Pharmacy – Bold"
  },
  {
    "id": "healthcare-pharmacy-medium",
    "industry": "Healthcare & Wellness",
    "subType": "Pharmacy",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1563213126-a4273aed2016?w=600&h=900&fit=crop",
    "label": "Pharmacy – Medium"
  },
  {
    "id": "healthcare-pharmacy-soft",
    "industry": "Healthcare & Wellness",
    "subType": "Pharmacy",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=600&h=900&fit=crop",
    "label": "Pharmacy – Soft"
  },
  {
    "id": "food-fine-dining-bold",
    "industry": "Food & Hospitality",
    "subType": "Fine Dining Restaurant",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&h=900&fit=crop",
    "label": "Fine Dining Restaurant – Bold"
  },
  {
    "id": "food-fine-dining-medium",
    "industry": "Food & Hospitality",
    "subType": "Fine Dining Restaurant",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&h=900&fit=crop",
    "label": "Fine Dining Restaurant – Medium"
  },
  {
    "id": "food-fine-dining-soft",
    "industry": "Food & Hospitality",
    "subType": "Fine Dining Restaurant",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1424847651672-bf20a4b0982b?w=600&h=900&fit=crop",
    "label": "Fine Dining Restaurant – Soft"
  },
  {
    "id": "food-casual-family-restaurant-bold",
    "industry": "Food & Hospitality",
    "subType": "Casual / Family Restaurant",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?w=600&h=900&fit=crop",
    "label": "Casual / Family Restaurant – Bold"
  },
  {
    "id": "food-casual-family-restaurant-medium",
    "industry": "Food & Hospitality",
    "subType": "Casual / Family Restaurant",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=600&h=900&fit=crop",
    "label": "Casual / Family Restaurant – Medium"
  },
  {
    "id": "food-casual-family-restaurant-soft",
    "industry": "Food & Hospitality",
    "subType": "Casual / Family Restaurant",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1521017432531-fbd92d768814?w=600&h=900&fit=crop",
    "label": "Casual / Family Restaurant – Soft"
  },
  {
    "id": "food-cafe-coffee-shop-bold",
    "industry": "Food & Hospitality",
    "subType": "Café & Coffee Shop",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=600&h=900&fit=crop",
    "label": "Café & Coffee Shop – Bold"
  },
  {
    "id": "food-cafe-coffee-shop-medium",
    "industry": "Food & Hospitality",
    "subType": "Café & Coffee Shop",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&h=900&fit=crop",
    "label": "Café & Coffee Shop – Medium"
  },
  {
    "id": "food-cafe-coffee-shop-soft",
    "industry": "Food & Hospitality",
    "subType": "Café & Coffee Shop",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=600&h=900&fit=crop",
    "label": "Café & Coffee Shop – Soft"
  },
  {
    "id": "food-street-food-qsr-bold",
    "industry": "Food & Hospitality",
    "subType": "Street Food / QSR",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&h=900&fit=crop",
    "label": "Street Food / QSR – Bold"
  },
  {
    "id": "food-street-food-qsr-medium",
    "industry": "Food & Hospitality",
    "subType": "Street Food / QSR",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1529006557810-274b9b2fc783?w=600&h=900&fit=crop",
    "label": "Street Food / QSR – Medium"
  },
  {
    "id": "food-street-food-qsr-soft",
    "industry": "Food & Hospitality",
    "subType": "Street Food / QSR",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?w=600&h=900&fit=crop",
    "label": "Street Food / QSR – Soft"
  },
  {
    "id": "food-bakery-desserts-bold",
    "industry": "Food & Hospitality",
    "subType": "Bakery & Desserts",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1486427944299-d1955d23e34d?w=600&h=900&fit=crop",
    "label": "Bakery & Desserts – Bold"
  },
  {
    "id": "food-bakery-desserts-medium",
    "industry": "Food & Hospitality",
    "subType": "Bakery & Desserts",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=600&h=900&fit=crop",
    "label": "Bakery & Desserts – Medium"
  },
  {
    "id": "food-bakery-desserts-soft",
    "industry": "Food & Hospitality",
    "subType": "Bakery & Desserts",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1517433670267-08bbd4be890f?w=600&h=900&fit=crop",
    "label": "Bakery & Desserts – Soft"
  },
  {
    "id": "food-bar-nightclub-bold",
    "industry": "Food & Hospitality",
    "subType": "Bar & Nightclub",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=600&h=900&fit=crop",
    "label": "Bar & Nightclub – Bold"
  },
  {
    "id": "food-bar-nightclub-medium",
    "industry": "Food & Hospitality",
    "subType": "Bar & Nightclub",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1543007630-9710e4a00a20?w=600&h=900&fit=crop",
    "label": "Bar & Nightclub – Medium"
  },
  {
    "id": "food-bar-nightclub-soft",
    "industry": "Food & Hospitality",
    "subType": "Bar & Nightclub",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=600&h=900&fit=crop",
    "label": "Bar & Nightclub – Soft"
  },
  {
    "id": "food-cloud-kitchen-delivery-bold",
    "industry": "Food & Hospitality",
    "subType": "Cloud Kitchen / Delivery",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=900&fit=crop",
    "label": "Cloud Kitchen / Delivery – Bold"
  },
  {
    "id": "food-cloud-kitchen-delivery-medium",
    "industry": "Food & Hospitality",
    "subType": "Cloud Kitchen / Delivery",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=600&h=900&fit=crop",
    "label": "Cloud Kitchen / Delivery – Medium"
  },
  {
    "id": "food-cloud-kitchen-delivery-soft",
    "industry": "Food & Hospitality",
    "subType": "Cloud Kitchen / Delivery",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=600&h=900&fit=crop",
    "label": "Cloud Kitchen / Delivery – Soft"
  },
  {
    "id": "hotels-luxury-hotel-bold",
    "industry": "Hotels & Travel",
    "subType": "Luxury Hotel",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=600&h=900&fit=crop",
    "label": "Luxury Hotel – Bold"
  },
  {
    "id": "hotels-luxury-hotel-medium",
    "industry": "Hotels & Travel",
    "subType": "Luxury Hotel",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=600&h=900&fit=crop",
    "label": "Luxury Hotel – Medium"
  },
  {
    "id": "hotels-luxury-hotel-soft",
    "industry": "Hotels & Travel",
    "subType": "Luxury Hotel",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=900&fit=crop",
    "label": "Luxury Hotel – Soft"
  },
  {
    "id": "hotels-boutique-hotel-bold",
    "industry": "Hotels & Travel",
    "subType": "Boutique Hotel",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1455587734955-081b22074882?w=600&h=900&fit=crop",
    "label": "Boutique Hotel – Bold"
  },
  {
    "id": "hotels-boutique-hotel-medium",
    "industry": "Hotels & Travel",
    "subType": "Boutique Hotel",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=600&h=900&fit=crop",
    "label": "Boutique Hotel – Medium"
  },
  {
    "id": "hotels-boutique-hotel-soft",
    "industry": "Hotels & Travel",
    "subType": "Boutique Hotel",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1505693314120-0d443867891c?w=600&h=900&fit=crop",
    "label": "Boutique Hotel – Soft"
  },
  {
    "id": "hotels-resort-pool-bold",
    "industry": "Hotels & Travel",
    "subType": "Resort & Pool",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1439130490301-25e322d88054?w=600&h=900&fit=crop",
    "label": "Resort & Pool – Bold"
  },
  {
    "id": "hotels-resort-pool-medium",
    "industry": "Hotels & Travel",
    "subType": "Resort & Pool",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=600&h=900&fit=crop",
    "label": "Resort & Pool – Medium"
  },
  {
    "id": "hotels-resort-pool-soft",
    "industry": "Hotels & Travel",
    "subType": "Resort & Pool",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=900&fit=crop",
    "label": "Resort & Pool – Soft"
  },
  {
    "id": "hotels-budget-business-hotel-bold",
    "industry": "Hotels & Travel",
    "subType": "Budget / Business Hotel",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=600&h=900&fit=crop",
    "label": "Budget / Business Hotel – Bold"
  },
  {
    "id": "hotels-budget-business-hotel-medium",
    "industry": "Hotels & Travel",
    "subType": "Budget / Business Hotel",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=600&h=900&fit=crop",
    "label": "Budget / Business Hotel – Medium"
  },
  {
    "id": "hotels-budget-business-hotel-soft",
    "industry": "Hotels & Travel",
    "subType": "Budget / Business Hotel",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1631049552057-403cdb8f0658?w=600&h=900&fit=crop",
    "label": "Budget / Business Hotel – Soft"
  },
  {
    "id": "hotels-travel-agency-bold",
    "industry": "Hotels & Travel",
    "subType": "Travel Agency",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1488085061387-422e29b40080?w=600&h=900&fit=crop",
    "label": "Travel Agency – Bold"
  },
  {
    "id": "hotels-travel-agency-medium",
    "industry": "Hotels & Travel",
    "subType": "Travel Agency",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1501555088652-021faa106b9b?w=600&h=900&fit=crop",
    "label": "Travel Agency – Medium"
  },
  {
    "id": "hotels-travel-agency-soft",
    "industry": "Hotels & Travel",
    "subType": "Travel Agency",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=600&h=900&fit=crop",
    "label": "Travel Agency – Soft"
  },
  {
    "id": "hotels-airbnb-homestay-bold",
    "industry": "Hotels & Travel",
    "subType": "Airbnb / Homestay",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1449158743715-0a90ebb6d2d8?w=600&h=900&fit=crop",
    "label": "Airbnb / Homestay – Bold"
  },
  {
    "id": "hotels-airbnb-homestay-medium",
    "industry": "Hotels & Travel",
    "subType": "Airbnb / Homestay",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=600&h=900&fit=crop",
    "label": "Airbnb / Homestay – Medium"
  },
  {
    "id": "hotels-airbnb-homestay-soft",
    "industry": "Hotels & Travel",
    "subType": "Airbnb / Homestay",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=600&h=900&fit=crop",
    "label": "Airbnb / Homestay – Soft"
  },
  {
    "id": "retail-fashion-boutique-bold",
    "industry": "Retail & Stores",
    "subType": "Fashion Boutique",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&h=900&fit=crop",
    "label": "Fashion Boutique – Bold"
  },
  {
    "id": "retail-fashion-boutique-medium",
    "industry": "Retail & Stores",
    "subType": "Fashion Boutique",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=600&h=900&fit=crop",
    "label": "Fashion Boutique – Medium"
  },
  {
    "id": "retail-fashion-boutique-soft",
    "industry": "Retail & Stores",
    "subType": "Fashion Boutique",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=600&h=900&fit=crop",
    "label": "Fashion Boutique – Soft"
  },
  {
    "id": "retail-electronics-store-bold",
    "industry": "Retail & Stores",
    "subType": "Electronics Store",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1491933382434-500287f9b54b?w=600&h=900&fit=crop",
    "label": "Electronics Store – Bold"
  },
  {
    "id": "retail-electronics-store-medium",
    "industry": "Retail & Stores",
    "subType": "Electronics Store",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1498049794561-7780e7231661?w=600&h=900&fit=crop",
    "label": "Electronics Store – Medium"
  },
  {
    "id": "retail-electronics-store-soft",
    "industry": "Retail & Stores",
    "subType": "Electronics Store",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1468495244123-6c6c332eeece?w=600&h=900&fit=crop",
    "label": "Electronics Store – Soft"
  },
  {
    "id": "retail-jewellery-store-bold",
    "industry": "Retail & Stores",
    "subType": "Jewellery Store",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&h=900&fit=crop",
    "label": "Jewellery Store – Bold"
  },
  {
    "id": "retail-jewellery-store-medium",
    "industry": "Retail & Stores",
    "subType": "Jewellery Store",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?w=600&h=900&fit=crop",
    "label": "Jewellery Store – Medium"
  },
  {
    "id": "retail-jewellery-store-soft",
    "industry": "Retail & Stores",
    "subType": "Jewellery Store",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1602173574767-37ac01994b2a?w=600&h=900&fit=crop",
    "label": "Jewellery Store – Soft"
  },
  {
    "id": "retail-supermarket-grocery-bold",
    "industry": "Retail & Stores",
    "subType": "Supermarket / Grocery",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1542838132-92c53300491e?w=600&h=900&fit=crop",
    "label": "Supermarket / Grocery – Bold"
  },
  {
    "id": "retail-supermarket-grocery-medium",
    "industry": "Retail & Stores",
    "subType": "Supermarket / Grocery",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1534723452862-4c874018d66d?w=600&h=900&fit=crop",
    "label": "Supermarket / Grocery – Medium"
  },
  {
    "id": "retail-supermarket-grocery-soft",
    "industry": "Retail & Stores",
    "subType": "Supermarket / Grocery",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=600&h=900&fit=crop",
    "label": "Supermarket / Grocery – Soft"
  },
  {
    "id": "retail-sports-fitness-store-bold",
    "industry": "Retail & Stores",
    "subType": "Sports & Fitness Store",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=600&h=900&fit=crop",
    "label": "Sports & Fitness Store – Bold"
  },
  {
    "id": "retail-sports-fitness-store-medium",
    "industry": "Retail & Stores",
    "subType": "Sports & Fitness Store",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=600&h=900&fit=crop",
    "label": "Sports & Fitness Store – Medium"
  },
  {
    "id": "retail-sports-fitness-store-soft",
    "industry": "Retail & Stores",
    "subType": "Sports & Fitness Store",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=600&h=900&fit=crop",
    "label": "Sports & Fitness Store – Soft"
  },
  {
    "id": "retail-home-decor-store-bold",
    "industry": "Retail & Stores",
    "subType": "Home Decor Store",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600&h=900&fit=crop",
    "label": "Home Decor Store – Bold"
  },
  {
    "id": "retail-home-decor-store-medium",
    "industry": "Retail & Stores",
    "subType": "Home Decor Store",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=600&h=900&fit=crop",
    "label": "Home Decor Store – Medium"
  },
  {
    "id": "retail-home-decor-store-soft",
    "industry": "Retail & Stores",
    "subType": "Home Decor Store",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=600&h=900&fit=crop",
    "label": "Home Decor Store – Soft"
  },
  {
    "id": "retail-gift-shop-bold",
    "industry": "Retail & Stores",
    "subType": "Gift Shop",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1512909006721-3d6018887383?w=600&h=900&fit=crop",
    "label": "Gift Shop – Bold"
  },
  {
    "id": "retail-gift-shop-medium",
    "industry": "Retail & Stores",
    "subType": "Gift Shop",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=600&h=900&fit=crop",
    "label": "Gift Shop – Medium"
  },
  {
    "id": "retail-gift-shop-soft",
    "industry": "Retail & Stores",
    "subType": "Gift Shop",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=600&h=900&fit=crop",
    "label": "Gift Shop – Soft"
  },
  {
    "id": "professional-lawyer-legal-firm-bold",
    "industry": "Professional Services",
    "subType": "Lawyer / Legal Firm",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&h=900&fit=crop",
    "label": "Lawyer / Legal Firm – Bold"
  },
  {
    "id": "professional-lawyer-legal-firm-medium",
    "industry": "Professional Services",
    "subType": "Lawyer / Legal Firm",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1453945619913-79ec89a82c51?w=600&h=900&fit=crop",
    "label": "Lawyer / Legal Firm – Medium"
  },
  {
    "id": "professional-lawyer-legal-firm-soft",
    "industry": "Professional Services",
    "subType": "Lawyer / Legal Firm",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=600&h=900&fit=crop",
    "label": "Lawyer / Legal Firm – Soft"
  },
  {
    "id": "professional-chartered-accountant-bold",
    "industry": "Professional Services",
    "subType": "Chartered Accountant",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=900&fit=crop",
    "label": "Chartered Accountant – Bold"
  },
  {
    "id": "professional-chartered-accountant-medium",
    "industry": "Professional Services",
    "subType": "Chartered Accountant",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=900&fit=crop",
    "label": "Chartered Accountant – Medium"
  },
  {
    "id": "professional-chartered-accountant-soft",
    "industry": "Professional Services",
    "subType": "Chartered Accountant",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=900&fit=crop",
    "label": "Chartered Accountant – Soft"
  },
  {
    "id": "professional-business-consultant-bold",
    "industry": "Professional Services",
    "subType": "Business Consultant",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=600&h=900&fit=crop",
    "label": "Business Consultant – Bold"
  },
  {
    "id": "professional-business-consultant-medium",
    "industry": "Professional Services",
    "subType": "Business Consultant",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=900&fit=crop",
    "label": "Business Consultant – Medium"
  },
  {
    "id": "professional-business-consultant-soft",
    "industry": "Professional Services",
    "subType": "Business Consultant",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=900&fit=crop",
    "label": "Business Consultant – Soft"
  },
  {
    "id": "professional-financial-advisor-bold",
    "industry": "Professional Services",
    "subType": "Financial Advisor",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=900&fit=crop",
    "label": "Financial Advisor – Bold"
  },
  {
    "id": "professional-financial-advisor-medium",
    "industry": "Professional Services",
    "subType": "Financial Advisor",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=900&fit=crop",
    "label": "Financial Advisor – Medium"
  },
  {
    "id": "professional-financial-advisor-soft",
    "industry": "Professional Services",
    "subType": "Financial Advisor",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=900&fit=crop",
    "label": "Financial Advisor – Soft"
  },
  {
    "id": "professional-architect-interior-designer-bold",
    "industry": "Professional Services",
    "subType": "Architect / Interior Designer",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&h=900&fit=crop",
    "label": "Architect / Interior Designer – Bold"
  },
  {
    "id": "professional-architect-interior-designer-medium",
    "industry": "Professional Services",
    "subType": "Architect / Interior Designer",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=600&h=900&fit=crop",
    "label": "Architect / Interior Designer – Medium"
  },
  {
    "id": "professional-architect-interior-designer-soft",
    "industry": "Professional Services",
    "subType": "Architect / Interior Designer",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?w=600&h=900&fit=crop",
    "label": "Architect / Interior Designer – Soft"
  },
  {
    "id": "professional-it-software-company-bold",
    "industry": "Professional Services",
    "subType": "IT / Software Company",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=900&fit=crop",
    "label": "IT / Software Company – Bold"
  },
  {
    "id": "professional-it-software-company-medium",
    "industry": "Professional Services",
    "subType": "IT / Software Company",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&h=900&fit=crop",
    "label": "IT / Software Company – Medium"
  },
  {
    "id": "professional-it-software-company-soft",
    "industry": "Professional Services",
    "subType": "IT / Software Company",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1497215842964-222b430dc094?w=600&h=900&fit=crop",
    "label": "IT / Software Company – Soft"
  },
  {
    "id": "professional-real-estate-agent-bold",
    "industry": "Professional Services",
    "subType": "Real Estate Agent",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&h=900&fit=crop",
    "label": "Real Estate Agent – Bold"
  },
  {
    "id": "professional-real-estate-agent-medium",
    "industry": "Professional Services",
    "subType": "Real Estate Agent",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=900&fit=crop",
    "label": "Real Estate Agent – Medium"
  },
  {
    "id": "professional-real-estate-agent-soft",
    "industry": "Professional Services",
    "subType": "Real Estate Agent",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=900&fit=crop",
    "label": "Real Estate Agent – Soft"
  },
  {
    "id": "beauty-hair-salon-bold",
    "industry": "Beauty & Personal Care",
    "subType": "Hair Salon",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&h=900&fit=crop",
    "label": "Hair Salon – Bold"
  },
  {
    "id": "beauty-hair-salon-medium",
    "industry": "Beauty & Personal Care",
    "subType": "Hair Salon",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1562322140-8baeececf3df?w=600&h=900&fit=crop",
    "label": "Hair Salon – Medium"
  },
  {
    "id": "beauty-hair-salon-soft",
    "industry": "Beauty & Personal Care",
    "subType": "Hair Salon",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?w=600&h=900&fit=crop",
    "label": "Hair Salon – Soft"
  },
  {
    "id": "beauty-barbershop-bold",
    "industry": "Beauty & Personal Care",
    "subType": "Barbershop",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=600&h=900&fit=crop",
    "label": "Barbershop – Bold"
  },
  {
    "id": "beauty-barbershop-medium",
    "industry": "Beauty & Personal Care",
    "subType": "Barbershop",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1585747860715-2ba37e788b70?w=600&h=900&fit=crop",
    "label": "Barbershop – Medium"
  },
  {
    "id": "beauty-barbershop-soft",
    "industry": "Beauty & Personal Care",
    "subType": "Barbershop",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=600&h=900&fit=crop",
    "label": "Barbershop – Soft"
  },
  {
    "id": "beauty-nail-studio-bold",
    "industry": "Beauty & Personal Care",
    "subType": "Nail Studio",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1604902396830-aca29e19b067?w=600&h=900&fit=crop",
    "label": "Nail Studio – Bold"
  },
  {
    "id": "beauty-nail-studio-medium",
    "industry": "Beauty & Personal Care",
    "subType": "Nail Studio",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600&h=900&fit=crop",
    "label": "Nail Studio – Medium"
  },
  {
    "id": "beauty-nail-studio-soft",
    "industry": "Beauty & Personal Care",
    "subType": "Nail Studio",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1604902396830-aca29e19b067?w=600&h=900&fit=crop",
    "label": "Nail Studio – Soft"
  },
  {
    "id": "beauty-spa-massage-bold",
    "industry": "Beauty & Personal Care",
    "subType": "Spa & Massage",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=600&h=900&fit=crop",
    "label": "Spa & Massage – Bold"
  },
  {
    "id": "beauty-spa-massage-medium",
    "industry": "Beauty & Personal Care",
    "subType": "Spa & Massage",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&h=900&fit=crop",
    "label": "Spa & Massage – Medium"
  },
  {
    "id": "beauty-spa-massage-soft",
    "industry": "Beauty & Personal Care",
    "subType": "Spa & Massage",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1571019613576-2b22c76fd955?w=600&h=900&fit=crop",
    "label": "Spa & Massage – Soft"
  },
  {
    "id": "beauty-makeup-artist-bold",
    "industry": "Beauty & Personal Care",
    "subType": "Makeup Artist",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=600&h=900&fit=crop",
    "label": "Makeup Artist – Bold"
  },
  {
    "id": "beauty-makeup-artist-medium",
    "industry": "Beauty & Personal Care",
    "subType": "Makeup Artist",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=600&h=900&fit=crop",
    "label": "Makeup Artist – Medium"
  },
  {
    "id": "beauty-makeup-artist-soft",
    "industry": "Beauty & Personal Care",
    "subType": "Makeup Artist",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1457972729786-0411a3b2b626?w=600&h=900&fit=crop",
    "label": "Makeup Artist – Soft"
  },
  {
    "id": "beauty-tattoo-studio-bold",
    "industry": "Beauty & Personal Care",
    "subType": "Tattoo Studio",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=600&h=900&fit=crop",
    "label": "Tattoo Studio – Bold"
  },
  {
    "id": "beauty-tattoo-studio-medium",
    "industry": "Beauty & Personal Care",
    "subType": "Tattoo Studio",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1611501275019-9b5cda994e8d?w=600&h=900&fit=crop",
    "label": "Tattoo Studio – Medium"
  },
  {
    "id": "beauty-tattoo-studio-soft",
    "industry": "Beauty & Personal Care",
    "subType": "Tattoo Studio",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1567526539-0078cf7a6ba2?w=600&h=900&fit=crop",
    "label": "Tattoo Studio – Soft"
  },
  {
    "id": "fitness-gym-fitness-center-bold",
    "industry": "Fitness & Sports",
    "subType": "Gym & Fitness Center",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&h=900&fit=crop",
    "label": "Gym & Fitness Center – Bold"
  },
  {
    "id": "fitness-gym-fitness-center-medium",
    "industry": "Fitness & Sports",
    "subType": "Gym & Fitness Center",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=600&h=900&fit=crop",
    "label": "Gym & Fitness Center – Medium"
  },
  {
    "id": "fitness-gym-fitness-center-soft",
    "industry": "Fitness & Sports",
    "subType": "Gym & Fitness Center",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=900&fit=crop",
    "label": "Gym & Fitness Center – Soft"
  },
  {
    "id": "fitness-yoga-studio-bold",
    "industry": "Fitness & Sports",
    "subType": "Yoga Studio",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=900&fit=crop",
    "label": "Yoga Studio – Bold"
  },
  {
    "id": "fitness-yoga-studio-medium",
    "industry": "Fitness & Sports",
    "subType": "Yoga Studio",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=600&h=900&fit=crop",
    "label": "Yoga Studio – Medium"
  },
  {
    "id": "fitness-yoga-studio-soft",
    "industry": "Fitness & Sports",
    "subType": "Yoga Studio",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=600&h=900&fit=crop",
    "label": "Yoga Studio – Soft"
  },
  {
    "id": "fitness-martial-arts-boxing-bold",
    "industry": "Fitness & Sports",
    "subType": "Martial Arts / Boxing",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=600&h=900&fit=crop",
    "label": "Martial Arts / Boxing – Bold"
  },
  {
    "id": "fitness-martial-arts-boxing-medium",
    "industry": "Fitness & Sports",
    "subType": "Martial Arts / Boxing",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1555597673-b21d5c935865?w=600&h=900&fit=crop",
    "label": "Martial Arts / Boxing – Medium"
  },
  {
    "id": "fitness-martial-arts-boxing-soft",
    "industry": "Fitness & Sports",
    "subType": "Martial Arts / Boxing",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1517438476312-10d79c077509?w=600&h=900&fit=crop",
    "label": "Martial Arts / Boxing – Soft"
  },
  {
    "id": "fitness-dance-studio-bold",
    "industry": "Fitness & Sports",
    "subType": "Dance Studio",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=600&h=900&fit=crop",
    "label": "Dance Studio – Bold"
  },
  {
    "id": "fitness-dance-studio-medium",
    "industry": "Fitness & Sports",
    "subType": "Dance Studio",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1547153760-18fc86324498?w=600&h=900&fit=crop",
    "label": "Dance Studio – Medium"
  },
  {
    "id": "fitness-dance-studio-soft",
    "industry": "Fitness & Sports",
    "subType": "Dance Studio",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1535525153412-5a42439a210d?w=600&h=900&fit=crop",
    "label": "Dance Studio – Soft"
  },
  {
    "id": "fitness-sports-coach-trainer-bold",
    "industry": "Fitness & Sports",
    "subType": "Sports Coach / Trainer",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&h=900&fit=crop",
    "label": "Sports Coach / Trainer – Bold"
  },
  {
    "id": "fitness-sports-coach-trainer-medium",
    "industry": "Fitness & Sports",
    "subType": "Sports Coach / Trainer",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=600&h=900&fit=crop",
    "label": "Sports Coach / Trainer – Medium"
  },
  {
    "id": "fitness-sports-coach-trainer-soft",
    "industry": "Fitness & Sports",
    "subType": "Sports Coach / Trainer",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=600&h=900&fit=crop",
    "label": "Sports Coach / Trainer – Soft"
  },
  {
    "id": "education-school-tuition-center-bold",
    "industry": "Education & Coaching",
    "subType": "School / Tuition Center",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=600&h=900&fit=crop",
    "label": "School / Tuition Center – Bold"
  },
  {
    "id": "education-school-tuition-center-medium",
    "industry": "Education & Coaching",
    "subType": "School / Tuition Center",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&h=900&fit=crop",
    "label": "School / Tuition Center – Medium"
  },
  {
    "id": "education-school-tuition-center-soft",
    "industry": "Education & Coaching",
    "subType": "School / Tuition Center",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=600&h=900&fit=crop",
    "label": "School / Tuition Center – Soft"
  },
  {
    "id": "education-professional-trainer-bold",
    "industry": "Education & Coaching",
    "subType": "Professional Trainer",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=900&fit=crop",
    "label": "Professional Trainer – Bold"
  },
  {
    "id": "education-professional-trainer-medium",
    "industry": "Education & Coaching",
    "subType": "Professional Trainer",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&h=900&fit=crop",
    "label": "Professional Trainer – Medium"
  },
  {
    "id": "education-professional-trainer-soft",
    "industry": "Education & Coaching",
    "subType": "Professional Trainer",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=600&h=900&fit=crop",
    "label": "Professional Trainer – Soft"
  },
  {
    "id": "education-music-school-bold",
    "industry": "Education & Coaching",
    "subType": "Music School",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=600&h=900&fit=crop",
    "label": "Music School – Bold"
  },
  {
    "id": "education-music-school-medium",
    "industry": "Education & Coaching",
    "subType": "Music School",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=600&h=900&fit=crop",
    "label": "Music School – Medium"
  },
  {
    "id": "education-music-school-soft",
    "industry": "Education & Coaching",
    "subType": "Music School",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1524230572899-a752b3835840?w=600&h=900&fit=crop",
    "label": "Music School – Soft"
  },
  {
    "id": "education-art-design-school-bold",
    "industry": "Education & Coaching",
    "subType": "Art & Design School",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=600&h=900&fit=crop",
    "label": "Art & Design School – Bold"
  },
  {
    "id": "education-art-design-school-medium",
    "industry": "Education & Coaching",
    "subType": "Art & Design School",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=600&h=900&fit=crop",
    "label": "Art & Design School – Medium"
  },
  {
    "id": "education-art-design-school-soft",
    "industry": "Education & Coaching",
    "subType": "Art & Design School",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1536924940846-227afb31e2a5?w=600&h=900&fit=crop",
    "label": "Art & Design School – Soft"
  },
  {
    "id": "education-language-institute-bold",
    "industry": "Education & Coaching",
    "subType": "Language Institute",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=600&h=900&fit=crop",
    "label": "Language Institute – Bold"
  },
  {
    "id": "education-language-institute-medium",
    "industry": "Education & Coaching",
    "subType": "Language Institute",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1546521343-4eb2c01aa44b?w=600&h=900&fit=crop",
    "label": "Language Institute – Medium"
  },
  {
    "id": "education-language-institute-soft",
    "industry": "Education & Coaching",
    "subType": "Language Institute",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=600&h=900&fit=crop",
    "label": "Language Institute – Soft"
  },
  {
    "id": "services-auto-repair-garage-bold",
    "industry": "Services & Trades",
    "subType": "Auto Repair / Garage",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1530046339160-ce3e530c7d2f?w=600&h=900&fit=crop",
    "label": "Auto Repair / Garage – Bold"
  },
  {
    "id": "services-auto-repair-garage-medium",
    "industry": "Services & Trades",
    "subType": "Auto Repair / Garage",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=600&h=900&fit=crop",
    "label": "Auto Repair / Garage – Medium"
  },
  {
    "id": "services-auto-repair-garage-soft",
    "industry": "Services & Trades",
    "subType": "Auto Repair / Garage",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1565689157206-0fddef7589a2?w=600&h=900&fit=crop",
    "label": "Auto Repair / Garage – Soft"
  },
  {
    "id": "services-electrician-plumber-bold",
    "industry": "Services & Trades",
    "subType": "Electrician / Plumber",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=600&h=900&fit=crop",
    "label": "Electrician / Plumber – Bold"
  },
  {
    "id": "services-electrician-plumber-medium",
    "industry": "Services & Trades",
    "subType": "Electrician / Plumber",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=600&h=900&fit=crop",
    "label": "Electrician / Plumber – Medium"
  },
  {
    "id": "services-electrician-plumber-soft",
    "industry": "Services & Trades",
    "subType": "Electrician / Plumber",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=900&fit=crop",
    "label": "Electrician / Plumber – Soft"
  },
  {
    "id": "services-cleaning-service-bold",
    "industry": "Services & Trades",
    "subType": "Cleaning Service",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?w=600&h=900&fit=crop",
    "label": "Cleaning Service – Bold"
  },
  {
    "id": "services-cleaning-service-medium",
    "industry": "Services & Trades",
    "subType": "Cleaning Service",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=900&fit=crop",
    "label": "Cleaning Service – Medium"
  },
  {
    "id": "services-cleaning-service-soft",
    "industry": "Services & Trades",
    "subType": "Cleaning Service",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=600&h=900&fit=crop",
    "label": "Cleaning Service – Soft"
  },
  {
    "id": "services-event-planner-bold",
    "industry": "Services & Trades",
    "subType": "Event Planner",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=600&h=900&fit=crop",
    "label": "Event Planner – Bold"
  },
  {
    "id": "services-event-planner-medium",
    "industry": "Services & Trades",
    "subType": "Event Planner",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=600&h=900&fit=crop",
    "label": "Event Planner – Medium"
  },
  {
    "id": "services-event-planner-soft",
    "industry": "Services & Trades",
    "subType": "Event Planner",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600&h=900&fit=crop",
    "label": "Event Planner – Soft"
  },
  {
    "id": "services-photographer-bold",
    "industry": "Services & Trades",
    "subType": "Photographer",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=600&h=900&fit=crop",
    "label": "Photographer – Bold"
  },
  {
    "id": "services-photographer-medium",
    "industry": "Services & Trades",
    "subType": "Photographer",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=600&h=900&fit=crop",
    "label": "Photographer – Medium"
  },
  {
    "id": "services-photographer-soft",
    "industry": "Services & Trades",
    "subType": "Photographer",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?w=600&h=900&fit=crop",
    "label": "Photographer – Soft"
  },
  {
    "id": "services-catering-service-bold",
    "industry": "Services & Trades",
    "subType": "Catering Service",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1555244162-803834f70033?w=600&h=900&fit=crop",
    "label": "Catering Service – Bold"
  },
  {
    "id": "services-catering-service-medium",
    "industry": "Services & Trades",
    "subType": "Catering Service",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=600&h=900&fit=crop",
    "label": "Catering Service – Medium"
  },
  {
    "id": "services-catering-service-soft",
    "industry": "Services & Trades",
    "subType": "Catering Service",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1547592180-85f173990554?w=600&h=900&fit=crop",
    "label": "Catering Service – Soft"
  },
  {
    "id": "personal-personal-brand-bold",
    "industry": "Personal",
    "subType": "Personal Brand",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=900&fit=crop",
    "label": "Personal Brand – Bold"
  },
  {
    "id": "personal-personal-brand-medium",
    "industry": "Personal",
    "subType": "Personal Brand",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1557683316-973673baf926?w=600&h=900&fit=crop",
    "label": "Personal Brand – Medium"
  },
  {
    "id": "personal-personal-brand-soft",
    "industry": "Personal",
    "subType": "Personal Brand",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600&h=900&fit=crop",
    "label": "Personal Brand – Soft"
  },
  {
    "id": "personal-freelancer-creator-bold",
    "industry": "Personal",
    "subType": "Freelancer / Creator",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1483058712412-4245e9b90334?w=600&h=900&fit=crop",
    "label": "Freelancer / Creator – Bold"
  },
  {
    "id": "personal-freelancer-creator-medium",
    "industry": "Personal",
    "subType": "Freelancer / Creator",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600&h=900&fit=crop",
    "label": "Freelancer / Creator – Medium"
  },
  {
    "id": "personal-freelancer-creator-soft",
    "industry": "Personal",
    "subType": "Freelancer / Creator",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?w=600&h=900&fit=crop",
    "label": "Freelancer / Creator – Soft"
  },
  {
    "id": "personal-influencer-artist-bold",
    "industry": "Personal",
    "subType": "Influencer / Artist",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1574169208507-84376144848b?w=600&h=900&fit=crop",
    "label": "Influencer / Artist – Bold"
  },
  {
    "id": "personal-influencer-artist-medium",
    "industry": "Personal",
    "subType": "Influencer / Artist",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1518640467707-6811f4a6ab73?w=600&h=900&fit=crop",
    "label": "Influencer / Artist – Medium"
  },
  {
    "id": "personal-influencer-artist-soft",
    "industry": "Personal",
    "subType": "Influencer / Artist",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600&h=900&fit=crop",
    "label": "Influencer / Artist – Soft"
  },
  {
    "id": "personal-doctor-personal-bold",
    "industry": "Personal",
    "subType": "Doctor Personal",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600&h=900&fit=crop",
    "label": "Doctor Personal – Bold"
  },
  {
    "id": "personal-doctor-personal-medium",
    "industry": "Personal",
    "subType": "Doctor Personal",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=900&fit=crop",
    "label": "Doctor Personal – Medium"
  },
  {
    "id": "personal-doctor-personal-soft",
    "industry": "Personal",
    "subType": "Doctor Personal",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=600&h=900&fit=crop",
    "label": "Doctor Personal – Soft"
  },
  {
    "id": "personal-executive-leader-bold",
    "industry": "Personal",
    "subType": "Executive / Leader",
    "variant": "bold",
    "imageUrl": "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&h=900&fit=crop",
    "label": "Executive / Leader – Bold"
  },
  {
    "id": "personal-executive-leader-medium",
    "industry": "Personal",
    "subType": "Executive / Leader",
    "variant": "medium",
    "imageUrl": "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=900&fit=crop",
    "label": "Executive / Leader – Medium"
  },
  {
    "id": "personal-executive-leader-soft",
    "industry": "Personal",
    "subType": "Executive / Leader",
    "variant": "soft",
    "imageUrl": "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=600&h=900&fit=crop",
    "label": "Executive / Leader – Soft"
  }
];

export const themeIndustries = Array.from(new Set(themes.map((theme) => theme.industry)));

export function getThemeById(themeId?: string | null): Theme | undefined {
  return themeId ? themes.find((theme) => theme.id === themeId) : undefined;
}
